import { render, staticRenderFns } from "./TabUserTokens.vue?vue&type=template&id=63bdd5d2"
import script from "./TabUserTokens.vue?vue&type=script&lang=js"
export * from "./TabUserTokens.vue?vue&type=script&lang=js"
import style0 from "./TabUserTokens.vue?vue&type=style&index=0&id=63bdd5d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports